import { DeleteDealRequestContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to delete a deal
 * @param request Deal deletion parameters
 * @returns Promise with void response
 */
export const deleteDealApi = async (request: DeleteDealRequestContent): Promise<void> => {
  const apiRequest = createApiRequest<void>('post', '/deals/delete');
  return apiRequest(request);
};
